import React from 'react'
import img from '../Content/Image/Profile.jpg'

export default function RightSide() {
  return (
    <>
    <div className="col-12 col-lg-3 col-md-4 p-0">
    <div className="col-12 mt2 ">
        <div className="rightside ">
            <div className="col-12 mt-2 px-5">
                <div className="img">
                    <img src={img} alt="profile"/>
                </div>
            </div>
            <div className="col-12">
                <h4 className="text-center text-white mt-2 fw-9">محمد امین کریمی</h4>
                    <p className="text-center text-small">Front-End Developer</p>
                    <div className="d-flex mt-4 social justify-content-center">
                        <a href="https://www.instagram.com/amiin_krimi?igsh=MWxoaXF4NnBoN2kxeA=="
                            target="_blank" title="Instagram">
                            <i className="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                        <a href="https://github.com/Aminkrimi" target="_blank" title="github">
                            <i className="fa fa-github" aria-hidden="true"></i>
                        </a>
                        <a href="https://t.me/AminKrimi" target="_blank" title="Telegram">
                            <i className="fa fa-telegram" aria-hidden="true"></i>
                        </a>
                        <a href="tel:+989391899523" target="_blank" title="Phone">
                            <i className="fa fa-phone" aria-hidden="true"></i>
                        </a>
                        <a href="mailto:m.amiin.krimi@gmail.com" target="_blank" title="Email">
                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                        </a>

                    </div>
            </div>
        </div>
    </div>
</div>
</>
  )
}
